import React from "react";
import { Grid } from "@material-ui/core";
import { Title, Margin } from "~/components/elements";

import ProductsDesk from "~/assets/img/products-list-images.png";
import calendarDesktop from "~/assets/img/calendar-desktop.png";
import calendarMobile from "~/assets/img/calendar-mobile.png";

import isMobile from "~/hooks/isMobile";
import * as S from "./styles";


export default function ParticipantProducts() {
  const mobile = isMobile();

  return (
    <S.Calendar>
      <S.Products>
        <img
          src={ProductsDesk}
          alt="Marcas praticipants"
        />
      </S.Products>
      <Grid container justifyContent="space-between">
        <Grid item xs={12} sm={12}>
          <Margin mr={mobile ? 2 : 0} ml={mobile ? 2 : 0}>
            <S.TitleSection>
              <Title level="4" primary as="4">
                <strong>Calendário </strong>
              </Title>
            </S.TitleSection>
          </Margin>
        </Grid>
      </Grid>

        <Grid container>
          <Grid item xs={12} sm={12}>
            <S.CalendarImage>
              <img src={mobile ? calendarMobile : calendarDesktop} alt="Calendário" />
            </S.CalendarImage>
          </Grid>
        </Grid>
      
    </S.Calendar>
  );
}
